// Mirrors app/javascript/src/components/dashboard/help_menu.vue from PR #5455.
// Keep this list aligned with that dashboard implementation until it is extracted into shared code.
export type HelpMenuLink = {
  id: 'whats_new' | 'quickstart' | 'help_center' | 'report_bug' | 'webinars' | 'download' | 'support';
  label: string;
  icon: 'gift' | 'video' | 'book' | 'bug' | 'webinar' | 'monitor-down' | 'message';
  href: string;
  kind: 'internal' | 'external';
};

export const helpMenuLinks: HelpMenuLink[] = [
  { id: 'whats_new', label: 'What’s New', icon: 'gift', href: 'https://zight.com/changelog/', kind: 'internal' },
  { id: 'quickstart', label: 'Quickstart', icon: 'video', href: 'https://www.youtube.com/watch?v=McQKTEISPvs', kind: 'internal' },
  { id: 'help_center', label: 'Help Center', icon: 'book', href: 'https://support.zight.com/hc/en-us', kind: 'external' },
  { id: 'report_bug', label: 'Report a Bug', icon: 'bug', href: 'https://support.zight.com/hc/en-us', kind: 'internal' },
  { id: 'webinars', label: 'Webinars', icon: 'webinar', href: 'https://zight.com/webinars/', kind: 'external' },
  { id: 'download', label: 'Download Desktop App', icon: 'monitor-down', href: 'https://zight.com/download/', kind: 'internal' },
  { id: 'support', label: 'Contact Support', icon: 'message', href: 'https://support.zight.com/hc/en-us#', kind: 'external' },
];
